import React from 'react';

// components
import LinkButton from '@src/components/buttons/CTA';

// content matrix components
import AccordionBlock from '@src/components/AccordionBlock';
import DonationForm from '@src/components/DonationForm';
import DynamicButton from '@src/components/buttons/DynamicButton';
import ImageCarousel from '@src/components/ImageCarousel';
import LinkBlocks from '@src/components/LinkBlocks';
import NewsletterSignup from '@src/components/NewsletterSignup';
import ProductsList from '@src/components/ProductsList';
import ProjectList from '@src/components/ProjectList';
import RelatedEventsList from '@src/components/RelatedEventsList';
import SingleMedia from '@src/components/SingleMedia';
import TextAndImage from '@src/components/TextAndImage';
import TwoUpImages from '@src/components/TwoUpImages';
import GiveCloudForm from '@src/components/GiveCloudForm';
import VideosBlock from '@src/components/VideosBlock';

export const renderSwitch = (block, i) => {
    switch (block.typeHandle) {
        case 'richTextBlock':
            return (
                <div
                    key={i}
                    className={`grid grid--1-2 relative ${block.actsAsHeader ? 'm-0' : 'spacing'} ${
                        i === 0 ? 'pt-24px lg:pt-36px' : ''
                    }`}>
                    <div>
                        <div
                            className="rich-text"
                            dangerouslySetInnerHTML={{ __html: block.initialText }}
                        />
                    </div>
                    <div style={{ marginTop: 5 }}>
                        <div
                            className={`rich-text mx-auto ${block.linkToEntry[0] ? 'mb-64px' : ''}`}
                            dangerouslySetInnerHTML={{ __html: block.richText }}
                        />
                        {block.linkToEntry[0] ? (
                            <div className="relative">
                                <LinkButton
                                    large
                                    to={`/${block.linkToEntry[0].uri}`}
                                    copy={block.linkToEntry[0].title}
                                />
                            </div>
                        ) : null}
                    </div>
                </div>
            );
        case 'excerptBlock':
            return (
                <div
                    key={i}
                    className={`relative border-top border-top--dashed spacing  ${
                        i === 0 ? 'pt-24px lg:pt-46' : ''
                    }`}>
                    <div
                        className="rich-text mx-auto"
                        dangerouslySetInnerHTML={{ __html: block.excerpt }}
                    />
                </div>
            );
        case 'productsBlock':
            return <ProductsList key={i} data={block} />;
        case 'relatedEventsBlock':
            return <RelatedEventsList key={i} data={block} />;
        case 'newsletterSignup':
            return (
                <div key={i} className="relative spacing">
                    <NewsletterSignup data={block} />
                </div>
            );
        case 'singleMedia':
            return (
                <div key={i} className={`relative spacing `}>
                    <SingleMedia data={block} />
                </div>
            );
        case 'textAndImageBlock':
            return (
                <div key={i} className={`relative spacing ${i === 0 ? 'pt-24px lg:pt-46' : ''}`}>
                    <TextAndImage data={block} />
                </div>
            );
        case 'twoUpImageBlock':
            return (
                <div key={i} className={`relative spacing `}>
                    <TwoUpImages data={block} />
                </div>
            );
        case 'imageCarousel':
            return (
                <div key={i} style={{ marginBottom: 88 }} className="relative">
                    <ImageCarousel images={block.carouselImages} />
                </div>
            );
        case 'projectList':
            return (
                <div key={i} className={`relative spacing ${i === 0 ? 'pt-24px lg:pt-46' : ''}`}>
                    <ProjectList />
                </div>
            );
        case 'giveCloudForm':
            return (
                <div key={i} className={`relative spacing `}>
                    <GiveCloudForm data={block} />
                </div>
            );
        case 'donationForm':
            return (
                <div key={i} className={`relative spacing `}>
                    <DonationForm data={block} />
                </div>
            );
        case 'linkBlocks':
            return (
                <div key={i} className={`relative spacing ${i === 0 ? 'pt-24px lg:pt-46' : ''}`}>
                    <LinkBlocks data={block} />
                </div>
            );
        case 'accordionBlock':
            return (
                <div key={i} className={`relative spacing ${i === 0 ? 'pt-24px lg:pt-46' : ''}`}>
                    <AccordionBlock data={block} />
                </div>
            );
        case 'dynamicButton':
            return (
                <div
                    key={i}
                    className={`relative spacing ${i === 0 ? 'pt-24px lg:pt-46' : ''}  ${
                        block.position === 'center' ? 'text-center' : ''
                    }`}>
                    <DynamicButton data={block} />
                </div>
            );
        case 'videosEmbedBlock':
            return (
                <div key={i} className={`relative spacing ${i === 0 ? 'pt-24px lg:pt-46' : ''}`}>
                    <VideosBlock data={block} />
                </div>
            );
        default:
            // eslint-disable-next-line no-console
            console.log('No typeHandle supplied for block: ', block);
            return null;
    }
};

export default renderSwitch;
